import withAuth from './withAuth'

export default withAuth



// WEBPACK FOOTER //
// ./src/components/withAuth/index.js